/**
 * Given a state object, return the EditorState of the most recently focused editor.
 * @param {Object} state
 * @returns {EditorState}
 */
import { get } from "dot-prop-immutable";
import { EditorState } from "draft-js";

export default function(state) {
  const {
    editor: {
      status: { activeEditor },
    },
  } = state;
  try {
    return get(state.editor.form, activeEditor.name);
  } catch (e) {
    return EditorState.createEmpty();
  }
}
